import { render, staticRenderFns } from "./CometConfigurationSection.vue?vue&type=template&id=24636a57&scoped=true"
import script from "./CometConfigurationSection.vue?vue&type=script&lang=js"
export * from "./CometConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24636a57",
  null
  
)

export default component.exports